"use client"

import { useEffect } from "react"
import Link from "next/link"
import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
import { Button } from "@/components/ui/button"
import { AlertCircle, Home, RefreshCw } from "lucide-react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to error reporting service
    console.error("Route error:", error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-16 md:py-24 text-center">
        {/* Error Icon */}
        <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <AlertCircle className="h-8 w-8 text-destructive" />
        </div>
        
        {/* Error Message */}
        <h1 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          Something went wrong
        </h1>
        
        <p className="mb-2 text-lg text-muted-foreground">
          We encountered an unexpected error while loading this page.
        </p>
        
        {error.digest && (
          <p className="mb-8 text-sm text-muted-foreground">
            Error ID: {error.digest}
          </p>
        )}

        {/* Actions */}
        <div className="flex flex-col gap-4 sm:flex-row">
          <Button
            variant="outline"
            size="lg"
            onClick={reset}
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Try Again
          </Button>
          
          <Button
            size="lg"
            className="bg-accent text-white hover:bg-accent/90"
            asChild
          >
            <Link href="/">
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  )
}





